import React, { Component } from 'react'
import './styles.scss'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import DefaultLayout from '../../../Layout/Default'
import Box from '../../../../Shared/Box'
import { Col, Container, Row } from '../../../../Shared/Grid'
import { adminGetSalesEmployees } from '../../../../../api'
import Loader from '../../../../Shared/Loader'
import Alert from '../../../../Shared/Alert'
import Button from '../../../../Shared/Form/Button'
import { EXPLOYEE_ORGANIZATIONS } from '../Shared/constants'

class EmployeeList extends Component {
  constructor (props) {
    super(props)

    this.state = {
      loading: false,
      employees: []

    }

    this.abortController = null
    this.organizationValueMap = []
    Object.keys(EXPLOYEE_ORGANIZATIONS).forEach((key) => {
        this.organizationValueMap[EXPLOYEE_ORGANIZATIONS[key].value] = EXPLOYEE_ORGANIZATIONS[key].label
      }
    )
  }

  componentDidMount () {
    this.search()
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  search = () => {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    this.setState({ loading: true, error: null }, () => {
      adminGetSalesEmployees(this.abortController).fetchPromise.then((response) => {
        this.setState({ employees: response, loading: false })
      }).catch(() => {
        this.setState({ error: 'Failed to get sales employees', loading: false })
      })
    })
  }

  createResultRow (salesEmployee) {
    const { t } = this.props
    return (
      <React.Fragment key={salesEmployee.id}>
        <tr>
          <td data-title={t('EMPLOYEE_GIATA_SALES_ID')}>{salesEmployee.giataSalesId}</td>
          <td data-title={t('EMPLOYEE_EMPLOYEE_CODE')}>{salesEmployee.employeeCode}</td>
          <td data-title={t('EMPLOYEE_ORGANIZATION')}>{this.organizationValueMap[salesEmployee.organizationId]}</td>
          <td data-title={t('EMAIL')}>{salesEmployee.email}</td>
          <td>
            <span className={'clearfix'} style={{ float: 'right', display: 'flex', alignItems: 'flex-end' }}>
              <Link to={'/admin/sales/employees/' + salesEmployee.id}>
                <i style={{ fontSize: '16.8px' }} className="fa fa-edit" aria-hidden="true"/>
              </Link>
            </span>
          </td>
        </tr>
      </React.Fragment>
    )
  }

  render () {
    const { t } = this.props

    let tbodyContent
    if (this.state.employees.length === 0) {
      tbodyContent = <tr>
        <td colSpan={8}>{t('NO_RESULTS_TO_SEARCH_FOUND')}</td>
      </tr>
    } else {
      tbodyContent = this.state.employees.map(v => this.createResultRow(v))
    }
    return (
      <DefaultLayout>
        <div className="salesEmployeeList">
          <Box style={{ position: 'relative' }} hasInnerBackground={true}>
            <Container fluid gutterWidth={5}>
              {this.state.loading && <Loader size={32}/>}
              <Row style={{ marginTop: '15px' }}>
                <Col xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                  <h3>{t('SALES_EMPLOYEES')}</h3>
                  <Button align="right"
                          style={{ margin: '0 0 0 auto' }}
                          onClick={() => {
                            this.props.history.push('/admin/sales/employees/add')
                          }}>{t('ADD')}</Button>
                </Col>
              </Row>
              {this.state.error && <Alert type={'danger'}>{this.state.error}</Alert>}
              {!this.state.error && <Row>
                <Container style={{ flex: 1 }} fluid gutterWidth={5}>
                  <Row>
                    <Col xs={12}>
                      <div className="flex-table" style={{ flex: 1 }}>
                        <div style={{ position: 'relative' }} className="table-responsive-vertical">
                          <table className="table table-hover table-mc-light-blue Gradient">
                            <thead>
                            <tr>
                              <td>{t('EMPLOYEE_GIATA_SALES_ID')}</td>
                              <td>{t('EMPLOYEE_EMPLOYEE_CODE')}</td>
                              <td>{t('EMPLOYEE_ORGANIZATION')}</td>
                              <td>{t('EMAIL')}</td>
                              <td/>
                            </tr>
                            </thead>
                            <tbody>
                            {tbodyContent}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Row>
              }
            </Container>
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

export default withTranslation()(EmployeeList)
